export const PATH_PLATFORM_BALANCE = "/member/invoices/platform-balance";

export const PATH_PLATFORM_BALANCE_TRANSACTIONS =
  PATH_PLATFORM_BALANCE + "/transactions";
